import { myProjects as projects } from "@/graphql/queries";

export const myProjects = {
  apollo: {
    projects: projects,
    $query: {
      fetchPolicy: 'network-only'
    }
  },
  computed: {
      myProjects () {
          return this.projects ? this.projects.filter(project => project.active) : [];
      },
      reducedProjectOptions () {
        return this.myProjects.reduce((accumulator, project) => {
          accumulator[project.id] = project.name
          return accumulator
        }, {})
      },
      inactiveProjects () {
        return this.projects ? this.projects.filter(project => !project.active) : [];
      }
  }
};
